import { createSlice, createSelector, createEntityAdapter, createAsyncThunk } from "@reduxjs/toolkit";
import { sortByFieldAlphabetically, sortByName } from "@amplio-common/funcs/commonFunctionalities";
import { TREATMENT_STATUSES } from "@app/constants";
import { simpleSetPayload } from "../constants";
import { loadMeasurements as loadMeasurementsPromise } from "@amplio-common/treatments/api";
import { SLICE_NAMES } from "./sliceNames";

//define root selector
const administrationSlice_STATE_ROOT_SELECTOR = state => state[SLICE_NAMES.ADMINISTRATION_SLICE];
const rootSelector = s => createSelector(administrationSlice_STATE_ROOT_SELECTOR, s);

const createSimpleSelector = (fieldName) => createSelector(
  [state => state[SLICE_NAMES.ADMINISTRATION_SLICE][fieldName]], field => field,
);


const sortFunc = sortByFieldAlphabetically("name");

export const studentsAdapter = createEntityAdapter({
  sortComparer: sortFunc,
});

export const loadMeasurements = createAsyncThunk(
  "measurements/load",
  async ({ studentId, treatmentId }) => {
    const { response } = await loadMeasurementsPromise(studentId, treatmentId);
    return { studentId, response };
  },
);

export const mapTSToStudentStatus = (ts) => ({
  id: ts.student.id,
  name: ts.student.name,
  first_name: ts.student.first_name,
  isStudentProfileDialogOpen: false,
  studentComment: ts.skip_reason || ts.summary_draft || "",
  isArrived: ts.status_id === TREATMENT_STATUSES.DONE.id || ts.summary_draft !== null || ts.calculated_actual_duration > 0,
  status_id: ts.status_id,
  summaries: ts.summaries,
  actualStart: ts.actual_start,
  loginCode: ts.student.fast_login_code,
  studentGrade: ts.student.student_grade,
  studentGoals: ts.student.goal_set,
});
  
const studentsAdapterSelectors = studentsAdapter.getSelectors(administrationSlice_STATE_ROOT_SELECTOR);

const initialState = {
  isEndDialogOpen: false,
  isQrCodeDialoOpen: false,
  isCancelDialogOpen: false,
  isWaitingRoomDialogOpen: false,
  isShowVideoPermissionsDialog: false,
  ...studentsAdapter.getInitialState(),
};



export const administrationSlice = createSlice({
  name: SLICE_NAMES.ADMINISTRATION_SLICE,
  initialState,
  reducers: {
    clearAdmin: () => ({ ...initialState }),
    setIsEndDialogOpen: simpleSetPayload("isEndDialogOpen"),
    setIsQrCodeDialoOpen: simpleSetPayload("isQrCodeDialoOpen"),
    setIsCancelDialogOpen: simpleSetPayload("isCancelDialogOpen"),
    setIsWaitingRoomDialogOpen: simpleSetPayload("isWaitingRoomDialogOpen"),
    setIsShowVideoPermissionsDialog: simpleSetPayload("isShowVideoPermissionsDialog"),
    
    updateStudentStatus: studentsAdapter.updateOne,
    setStudentsStatus: studentsAdapter.setAll,
    updateAllStudents: studentsAdapter.updateMany,
    // setSomeField: (state, action) => { state.someField = action.payload; },

  },
});

export default administrationSlice.reducer;

//actions
export const { updateStudentStatus, setStudentsStatus, updateAllStudents,
  setIsEndDialogOpen, setIsQrCodeDialoOpen, setIsCancelDialogOpen, setIsShowVideoPermissionsDialog,
  setIsWaitingRoomDialogOpen, clearAdmin } = administrationSlice.actions;

//selectors
export const selectIsEndDialogOpen = createSimpleSelector("isEndDialogOpen");
export const selectIsQrCodeDialoOpen = createSimpleSelector("isQrCodeDialoOpen");
export const selectIsCancelDialogOpen = createSimpleSelector("isCancelDialogOpen");
export const selectIsWaitingRoomDialogOpen = createSimpleSelector("isWaitingRoomDialogOpen");
export const selectIsShowVideoPermissionsDialog = createSimpleSelector("isShowVideoPermissionsDialog");

// TODO - refactor
export const selectArrivedStudents = arrived => rootSelector(t => Object.values(t.entities).filter(
  s => arrived ? s.isArrived : !s.isArrived,
).sort(sortByName).map(s => s.id));

export const { selectAll: selectAllStudentsStatus, selectIds: selectStudentStatusIds,
  selectById: selectStudentStatusById } = studentsAdapterSelectors;
